export const LOADING = 'loading';
export const LOADED = 'loaded';
export const FAILED = 'failed';
export const LOADING_STATUS = 'LOADING_STATUS';
